import {
    GET_TRANSACTION_PROVISION_LIST,
    GET_TRANSACTION_PROVISION_LIST_SUCCESS,
    GET_TRANSACTION_PROVISION_SEARCH,
    GET_TRANSACTION_PROVISION_SEARCH_SUCCESS,
    GET_TRANSACTION_PROVISION_LINKED_AMOUNTS,
    GET_TRANSACTION_PROVISION_LINKED_AMOUNTS_SUCCESS,
    GET_TRANSACTION_PROVISION_SETTLE_LINKED_AMOUNTS,
    GET_TRANSACTION_PROVISION_SETTLE_LINKED_AMOUNTS_SUCCESS,
    TRANSACTION_PROVISION_API_ERROR
} from "./actionTypes"

export const getTransactionProvisionList = record => ({
    type: GET_TRANSACTION_PROVISION_LIST,
    payload: record
})

export const getTransactionProvisionListSuccess = record => ({
    type: GET_TRANSACTION_PROVISION_LIST_SUCCESS,
    payload: record
})

export const getTransactionProvisionSearch = record => ({
    type: GET_TRANSACTION_PROVISION_SEARCH,
    payload: record,
})
export const getTransactionProvisionSearchSuccess = record => ({
    type: GET_TRANSACTION_PROVISION_SEARCH_SUCCESS,
    payload: record,
})
export const getTransactionProvisionLinkedAmounts = record => ({
    type: GET_TRANSACTION_PROVISION_LINKED_AMOUNTS,
    payload: record,
})
export const getTransactionProvisionLinkedAmountsSuccess = record => ({
    type: GET_TRANSACTION_PROVISION_LINKED_AMOUNTS_SUCCESS,
    payload: record,
})
export const getTransactionProvisionSettleLinkedAmounts = record => ({
    type: GET_TRANSACTION_PROVISION_SETTLE_LINKED_AMOUNTS,
    payload: record,
})
export const getTransactionProvisionSettleLinkedAmountsSuccess = record => ({
    type: GET_TRANSACTION_PROVISION_SETTLE_LINKED_AMOUNTS_SUCCESS,
    payload: record,
})

export const transactionProvisionApiError = error => {
    return {
        type: TRANSACTION_PROVISION_API_ERROR,
        payload: error,
    }
}
